@if (access()) {
  @if ((accessTimes()?.length || 0) > 0) {
    <p>
      Mit diesem QR-Code kannst du die Halle zum Zeitpunkt deiner Buchungen betreten, bitte halte den Code hierzu einfach in die Kamera.
      Wenn gewünscht kannst du auch den PIN beim entsprechenden Terminal verwenden.
    </p>
    <ul>
      @for (time of accessTimes(); track time) {
        <li>
          {{ { date: time.from, format: 'dd.LL.yyyy HH:mm' } | luxon }}
          -
          {{ { date: time.until, format: 'HH:mm' } | luxon }}
        </li>
      }
      <div class="w-full flex flex-col justify-center items-center mt-12">
        @if (accessQRCode(); as code) {
          <img [src]="code" />
        }
        @if (accessPin(); as pin) {
          <div>PIN: {{ pin }}</div>
        }
      </div>
    </ul>
  } @else {
    <p class="m-0">Da du keine Buchungen offen hast, ist der Zugang aktuell gesperrt.</p>
  }
}
